/* eslint-disable react/jsx-pascal-case */
import React, { useContext } from 'react'
import styled from 'styled-components'
import { Box, Card, Flex, Hide, Text, BlockLink } from 'pcln-design-system'
import { WebPBackgroundImage } from '@pcln/content-tile'
import { tryCatch, always, isEmpty, pathOr } from 'ramda'
import BootstrapDataContext from '../../../context/BootstrapDataContext'
import CONTENT from './content'

const Wrapper = styled(Card)`
  height: 340px;
  ${props => props.theme.mediaQueries[3]} {
    height: 250px;
  }
  background-color: white;
  border-radius: 4px;
`

const FlexWithTopBorder = styled(Flex)<{ borderColor: string }>`
  border-top: 6px solid ${props => props.borderColor || props.theme.colors.blue};
  height: 100%;
  border-radius: 3px;
`

const Headline = styled(Text)`
  line-height: 36px;
`

const ImageOnRightWebP = styled(WebPBackgroundImage)`
  align-self: flex-start;
  height: 100%;
  object-fit: cover;
  object-position: -40px;
  position: relative;
  border-bottom-right-radius: 3px;
  right: 0;
  background-color: #fff;
`

const ImageOnTopWebP = styled(WebPBackgroundImage)`
  width: 100%;
  flex-shrink: 0;
  object-fit: cover;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background-color: #fff;
`

const TextWrapper = styled(Flex)`
  height: 210px;
  width: 100%;
  ${props => props.theme.mediaQueries[3]} {
    height: 240px;
  }
`

const BoxLink = styled(BlockLink)`
  height: 100%;
  &:hover {
    text-decoration: none !important;
    color: inherit;
    overflow: visible;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 6px 0px,
      rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
    border-width: 1px;
    border-color: rgb(192, 202, 213);
    border-image: initial;
    border-radius: 3px;
  }
`

const PromoBox = ({
  children,
  boxLink,
  analytics
}: {
  children: React.ReactNode
  boxLink: string
  analytics: () => void
}) => {
  return boxLink ? (
    <BoxLink onClick={analytics} href={boxLink}>
      {children}
    </BoxLink>
  ) : (
    <Box>{children}</Box>
  )
}

export default function KaleyPromoAdBox() {
  const { aceContent } = useContext(BootstrapDataContext)
  const data = pathOr(
    '{}',
    [
      'contentValues',
      'HOMEPAGE',
      'SITE-X.HOMEPAGE.PROMOTIONSBANNER.KALEYPROMOADBOX',
      'value'
    ],
    aceContent
  )
  const adBoxValues = tryCatch(JSON.parse, always({}))(data)
  const {
    headline1,
    headline1Color,
    headline1FontSize,
    headline2,
    headline2Color,
    headline2FontSize,
    subHeadline,
    subHeadlineColor,
    subHeadlineFontSize,
    moreInfoText,
    boxLink,
    borderTopColor,
    desktopImageJPGUrl,
    desktopImageWEBPUrl,
    tabletImageJPGUrl,
    tabletImageWEBPUrl,
    analytics
  } = isEmpty(adBoxValues) ? CONTENT : adBoxValues

  return (
    <Wrapper
      boxShadowSize="md"
      mx={2}
      width={['30%', null, null, null, '410px']}
    >
      <PromoBox boxLink={boxLink} analytics={analytics}>
        <FlexWithTopBorder
          flexDirection={['column', null, null, null, 'row']}
          borderColor={borderTopColor}
        >
          <Hide xl xxl>
            <ImageOnTopWebP
              height="115px"
              image={tabletImageJPGUrl}
              imageWebP={tabletImageWEBPUrl}
            />
          </Hide>
          <TextWrapper flexDirection="column" p={3}>
            <Headline
              mt="-6px"
              fontSize={headline1FontSize || 5}
              color={headline1Color || 'primary'}
              fontWeight="bold"
            >
              {headline1} <br />
              <Text.span
                fontSize={headline2FontSize || 5}
                style={{ lineHeight: '36px' }}
                color={headline2Color || 'text'}
                fontWeight="bold"
              >
                {headline2}
              </Text.span>
            </Headline>
            <Text
              fontSize={subHeadlineFontSize || 1}
              color={subHeadlineColor || 'text'}
              mt={2}
              style={{ lineHeight: '24px' }}
            >
              {subHeadline}
            </Text>
            <Text
              color="darkGray"
              fontSize="11px"
              mt={[20, null, null, 'auto']}
            >
              {moreInfoText}
            </Text>
          </TextWrapper>
          <Hide xs sm md lg width={1}>
            <ImageOnRightWebP
              height="100%"
              image={desktopImageJPGUrl}
              imageWebP={desktopImageWEBPUrl}
            />
          </Hide>
        </FlexWithTopBorder>
      </PromoBox>
    </Wrapper>
  )
}
